const referralInitial = {
  referralPageDetails: {},
  earningsDetails: {},
  totalEarning: {},
  referrerDetails: {},
  faqs: [],
  refereeIncentive: 0
};

export default function ReferralData(state = referralInitial, action) {
  switch (action.type) {
    case 'SET_REFERRAL_PAGE_DETAILS':
      return { ...state, referralPageDetails: action.referralPageDetails };

    case 'SET_REFERRAL_PAGE_FAQS':
      return { ...state, faqs: action.faqs };

    case 'SET_REFERRAL_EARNINGS_DETAILS':
      return { ...state, earningsDetails: action.earningsDetails };

    case 'SET_REFERRAL_TOTAL_EARNINGS':
      return { ...state, totalEarning: action.totalEarning };

    case 'SET_REFERRER_DETAILS':
      return { ...state, referrerDetails: action.referrerDetails };

    case 'SET_REFERRER_EARNINGS_FETCH_STATUS':
      return { ...state, referralEarningFetchStatus: action.referralEarningFetchStatus };

    case 'SET_REFEREE_INCENTIVE':
      return {
        ...state,
        refereeIncentive: action.refereeIncentive,
        refereeIncentiveExpiresIn: action.refereeIncentiveExpiresIn
      };

    case 'SET_ANONYMOUS_REFERRER_INCENTIVE':
      return {
        ...state,
        anonymousReferrerIncentive: action.anonymousReferrerIncentive
      };
    case 'SET_REFERRAL_DEFAULT_STATE':
      return {};
    default:
      return state;
  }
}
